import {
  FETCH_NAV_ATHLETES_START,
  FETCH_NAV_ATHLETES_FULFILLED,
  FETCH_NAV_ATHLETES_REJECTED,
  FETCH_NAV_ATHLETE_ASSIGNMENTS_START,
  FETCH_NAV_ATHLETE_ASSIGNMENTS_FULFILLED,
  FETCH_NAV_ATHLETE_ASSIGNMENTS_REJECTED,
  FETCH_NAV_CALENDARS_START,
  FETCH_NAV_CALENDARS_FULFILLED,
  FETCH_NAV_CALENDARS_REJECTED,
  FETCH_NAV_CALENDAR_PREVIEW_START,
  FETCH_NAV_CALENDAR_PREVIEW_FULFILLED,
  FETCH_NAV_CALENDAR_PREVIEW_REJECTED,
  FETCH_NAV_CALENDAR_ITEMS_START,
  FETCH_NAV_CALENDAR_ITEMS_FULFILLED,
  FETCH_NAV_CALENDAR_ITEMS_REJECTED,
  FETCH_NAV_PROGRAMS_START,
  FETCH_NAV_PROGRAMS_FULFILLED,
  FETCH_NAV_PROGRAMS_REJECTED,
  FETCH_NAV_PROGRAM_ITEMS_START,
  FETCH_NAV_PROGRAM_ITEMS_FULFILLED,
  FETCH_NAV_PROGRAM_ITEMS_REJECTED,
  FETCH_NAV_PROGRAM_DAY_ONE_START,
  FETCH_NAV_PROGRAM_DAY_ONE_FULFILLED,
  FETCH_NAV_PROGRAM_DAY_ONE_REJECTED,
  FETCH_NAV_PROGRAM_PREVIEW_START,
  FETCH_NAV_PROGRAM_PREVIEW_FULFILLED,
  FETCH_NAV_PROGRAM_PREVIEW_REJECTED,
  FETCH_NAV_WORKOUT_RESULTS_START,
  FETCH_NAV_WORKOUT_RESULTS_FULFILLED,
  FETCH_NAV_WORKOUT_RESULTS_REJECTED,
  FETCH_NAV_DAY_WORKOUT_ITEMS_START,
  FETCH_NAV_DAY_WORKOUT_ITEMS_FULFILLED,
  FETCH_NAV_DAY_WORKOUT_ITEMS_REJECTED,
  SET_IS_PREVIEW_CAROUSEL_SHOWING,
} from './actionTypes';

const initialState = {
  isLoadingAthletes: false,
  isLoadingAthleteAssignments: false,
  isLoadingCalendars: false,
  isLoadingCalendarItems: false,
  isLoadingCalendarPreview: false,
  isLoadingPrograms: false,
  isLoadingProgramItems: false,
  isLoadingProgramDayOne: false,
  isLoadingProgramPreview: false,
  isLoadingWorkoutResults: false,
  isLoadingWorkoutsList: false,
  isPreviewCarouselShowing: false,
};

// eslint-disable-next-line default-param-last
export default function navigatorUIReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_NAV_ATHLETES_START:
      return {
        ...state,
        isLoadingAthletes: true,
      };
    case FETCH_NAV_ATHLETES_FULFILLED:
      return {
        ...state,
        isLoadingAthletes: false,
      };
    case FETCH_NAV_ATHLETES_REJECTED:
      return {
        ...state,
        isLoadingAthletes: false,
      };
    case FETCH_NAV_ATHLETE_ASSIGNMENTS_START:
      return {
        ...state,
        isLoadingAthleteAssignments: true,
      };
    case FETCH_NAV_ATHLETE_ASSIGNMENTS_FULFILLED:
      return {
        ...state,
        isLoadingAthleteAssignments: false,
      };
    case FETCH_NAV_ATHLETE_ASSIGNMENTS_REJECTED:
      return {
        ...state,
        isLoadingAthleteAssignments: false,
      };
    case FETCH_NAV_CALENDARS_START:
      return {
        ...state,
        isLoadingCalendars: true,
      };
    case FETCH_NAV_CALENDARS_FULFILLED:
      return {
        ...state,
        isLoadingCalendars: false,
      };
    case FETCH_NAV_CALENDARS_REJECTED:
      return {
        ...state,
        isLoadingCalendars: false,
      };
    case FETCH_NAV_CALENDAR_ITEMS_START:
      return {
        ...state,
        isLoadingCalendarItems: true,
      };
    case FETCH_NAV_CALENDAR_ITEMS_FULFILLED:
      return {
        ...state,
        isLoadingCalendarItems: false,
      };
    case FETCH_NAV_CALENDAR_ITEMS_REJECTED:
      return {
        ...state,
        isLoadingCalendarItems: false,
      };
    case FETCH_NAV_CALENDAR_PREVIEW_START:
      return {
        ...state,
        isLoadingCalendarPreview: true,
      };
    case FETCH_NAV_CALENDAR_PREVIEW_FULFILLED:
      return {
        ...state,
        isLoadingCalendarPreview: false,
      };
    case FETCH_NAV_CALENDAR_PREVIEW_REJECTED:
      return {
        ...state,
        isLoadingCalendarPreview: false,
      };
    case FETCH_NAV_PROGRAMS_START:
      return {
        ...state,
        isLoadingPrograms: true,
      };
    case FETCH_NAV_PROGRAMS_FULFILLED:
      return {
        ...state,
        isLoadingPrograms: false,
      };
    case FETCH_NAV_PROGRAMS_REJECTED:
      return {
        ...state,
        isLoadingPrograms: false,
      };
    case FETCH_NAV_PROGRAM_ITEMS_START:
      return {
        ...state,
        isLoadingProgramItems: true,
      };
    case FETCH_NAV_PROGRAM_ITEMS_FULFILLED:
      return {
        ...state,
        isLoadingProgramItems: false,
      };
    case FETCH_NAV_PROGRAM_ITEMS_REJECTED:
      return {
        ...state,
        isLoadingProgramItems: false,
      };
    case FETCH_NAV_PROGRAM_DAY_ONE_START:
      return {
        ...state,
        isLoadingProgramDayOne: true,
      };
    case FETCH_NAV_PROGRAM_DAY_ONE_FULFILLED:
      return {
        ...state,
        isLoadingProgramDayOne: false,
      };
    case FETCH_NAV_PROGRAM_DAY_ONE_REJECTED:
      return {
        ...state,
        isLoadingProgramDayOne: false,
      };
    case FETCH_NAV_PROGRAM_PREVIEW_START:
      return {
        ...state,
        isLoadingProgramPreview: true,
      };
    case FETCH_NAV_PROGRAM_PREVIEW_FULFILLED:
      return {
        ...state,
        isLoadingProgramPreview: false,
      };
    case FETCH_NAV_PROGRAM_PREVIEW_REJECTED:
      return {
        ...state,
        isLoadingProgramPreview: false,
      };
    case FETCH_NAV_WORKOUT_RESULTS_START:
      return {
        ...state,
        isLoadingWorkoutResults: true,
      };
    case FETCH_NAV_WORKOUT_RESULTS_FULFILLED:
      return {
        ...state,
        isLoadingWorkoutResults: false,
      };
    case FETCH_NAV_WORKOUT_RESULTS_REJECTED:
      return {
        ...state,
        isLoadingWorkoutResults: false,
      };
    case FETCH_NAV_DAY_WORKOUT_ITEMS_START:
      return {
        ...state,
        isLoadingWorkoutsList: true,
      };
    case FETCH_NAV_DAY_WORKOUT_ITEMS_FULFILLED:
      return {
        ...state,
        isLoadingWorkoutsList: false,
      };
    case FETCH_NAV_DAY_WORKOUT_ITEMS_REJECTED:
      return {
        ...state,
        isLoadingWorkoutsList: false,
      };
    case SET_IS_PREVIEW_CAROUSEL_SHOWING:
      return {
        ...state,
        isPreviewCarouselShowing: action.payload,
      };
    default:
      return state;
  }
}
